import { render, staticRenderFns } from "./ApplicantRegister.vue?vue&type=template&id=5bcd27ef&scoped=true&"
import script from "../../services/applicant/applicant-register.js?vue&type=script&lang=js&"
export * from "../../services/applicant/applicant-register.js?vue&type=script&lang=js&"
import style0 from "./ApplicantRegister.vue?vue&type=style&index=0&id=5bcd27ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcd27ef",
  null
  
)

export default component.exports